import React, { useState } from "react";
import TemplateArticleHelp from "../TemplateArticleHelp/TemplateArticleHelp";
import styles from "./DocumentManagement.module.css";
import { ReactComponent as GreenDotsAppIcon } from "../../../assets/GreenDotsAppIcon.svg";
import { ReactComponent as ArrowDownBold } from "../../../assets/arrowDownBold.svg";
// import { ReactComponent as BlackWarningIcon } from "../../../assets/BlackWarningIcon.svg";
import { ReactComponent as ConectionsGrayIcon } from "../../../assets/ConectionsGrayIcon.svg";
import { ReactComponent as HouseIcon } from "../../../assets/HouseIcon.svg";
// import { ReactComponent as RocketIcon } from "../../../assets/rocketIcon.svg";
import { ReactComponent as ArrowRightText } from "../../../assets/arrowRightText.svg";
import { ReactComponent as FilterIconBars } from "../../../assets/S3/filterIconBars.svg";
import { useTranslation } from "react-i18next";

const DocumentManagement = ({ setSelectedCategory }) => {
  const { t } = useTranslation("helpPage");

  const [activeArticles, setActiveArticles] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
  });

  const handleClick = (index) => {
    setActiveArticles((prevState) => ({
      ...prevState,
      [index]: !prevState[index], 
    }));
  };

  return (
    <div>
      <TemplateArticleHelp
        title={t("documentManagement")}
        description={t("documentManagementDesc")}
        Icon={GreenDotsAppIcon}
        setSelectedCategory={setSelectedCategory}
      >
        <div className={styles.articlesContent}>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(1)} 
            >
              {t("fileUpload")} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[1] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              {t("toManageDocuments")}
              <ul>
                <li>{t("uploadFilesManually")}</li>
                <br />
                <br />
                <li>{t("dragAndDropFiles")}</li>
              </ul>
              <br />
              <br />
              {t("automateSynchronization")} <ConectionsGrayIcon />
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(2)} 
            >
              {t("navigateFolders")} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[2] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              {t("atBottomScreen")}
              <br />
              <div className={styles.bottomMenu}>
                <div
                  className={styles.houseContainer}
                  onClick={() => dispatch(setCurrentPath(user.id + "/"))}
                >
                  <HouseIcon
                    className={`${styles.icon} ${styles.house}`}
                  />{" "}
                </div>
                <ArrowRightText /> 2025 <ArrowRightText /> {""}
                <strong>Q1</strong>
              </div>
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t("classificationConcepts")} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              {t("customizeConcepts")}
              <ul>
                <li> {t("customizeConeptsList1")} </li>
                <li>{t("customizeConeptsList2")}</li>
                <li>{t("customizeConeptsList3")}</li>
                <li>{t("customizeConeptsList4")}</li>
                <li>{t("customizeConeptsList5")}</li>
                <li>{t("customizeConeptsList6")}</li>
              </ul>
              <br />
              <span>{t('advancedFilters')}</span>{" "}
              <FilterIconBars
                style={{
                  transform: "translateY(6px)",
                  display: "inline-block",
                }}
              />
            </div>
          </div>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
              {t('quickActions')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
              <ul>
                <li>
                  {t('quickActionsList1')}
                </li>
                <li>
                {t('quickActionsList2')}
                </li>
                <li>
                {t('quickActionsList3')}
                </li>
                <li>
                {t('quickActionsList4')}
                </li>
                <li>
                {t('quickActionsList5')}
                </li>
                <li>
                {t('quickActionsList6')}
                </li>
                <li>
                {t('quickActionsList7')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </TemplateArticleHelp>
    </div>
  );
};

export default DocumentManagement;
